module.exports = __webpack_public_path__ + "static/media/icon-calendar.2d87c518.svg";